const RGX_NAME_KANA = /^[ァ-ヶーｧ-ﾝﾞﾟ　]+$/;
const NUMBER_PHONES = /^0\d{8,10}$/;
const REGEX_POSTCODE = /^\d{3}-?\d{4,17}$/;
const REGEX_CHARACTER = /\d/g;
const REGEX_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export {
  RGX_NAME_KANA,
  NUMBER_PHONES,
  REGEX_POSTCODE,
  REGEX_CHARACTER,
  REGEX_EMAIL
}
